export const yearsOperating = [
  { value: 'less_than_one_year', label: 'Less than 1 Year' },
  { value: 'one_to_three_years', label: '1-2 Years' },
  { value: 'three_to_five_years', label: '3-4 Years' },
  { value: 'five_to_ten_years', label: '5-9 Years' },
  { value: 'more_than_ten_years', label: '10+ Years' }
];

export const sortBy = [
  { value: 'recently_updated', label: 'Recently Updated' },
  { value: 'completeness', label: 'Completeness' }
];

export const timeframes = [
  { value: 'ytd', label: 'YTD' },
  { value: 'ltm', label: 'LTM' },
  { value: 'one_year', label: '1 Year' },
  { value: 'three_year', label: '3 Year' },
  { value: 'five_year', label: '5 Year' }
];

export const quartiles = [
  { value: 'first_q', label: 'First Quartile' },
  { value: 'second_q', label: 'Second Quartile' },
  { value: 'third_q', label: 'Third Quartile' },
  { value: 'fourth_q', label: 'Fourth Quartile' }
];

export const visibleResearchOptions = [
  { value: 'zero_ideas', label: '0 Ideas' },
  { value: 'one_to_two_ideas', label: '1-2 Ideas' },
  { value: 'three_to_nine_ideas', label: '3-9 Ideas' },
  { value: 'more_than_ten_ideas', label: '10+ Ideas' }
];

export const managementFee = [
  { value: 'less_than_one', label: 'Less than 1%' },
  { value: 'between_one_and_two', label: 'Between 1% and 2%' },
  { value: 'more_than_two', label: 'More than 2%' }
];

export const incentiveFee = [
  { value: 'less_than_ten', label: 'Less than 10%' },
  { value: 'between_ten_and_twenty', label: 'Between 10% and 20%' },
  { value: 'more_than_twenty', label: 'More than 20%' }
];

export const yesNo = [{ value: 'Yes', label: 'Yes' }, { value: 'No', label: 'No' }];

export const allocatorActivity = [
  { value: 'high', label: 'high' },
  { value: 'medium', label: 'medium' },
  { value: 'low', label: 'low' }
];
